import { render, staticRenderFns } from "./WeaponWidget.vue?vue&type=template&id=23f87ed2&scoped=true"
import script from "./WeaponWidget.vue?vue&type=script&lang=js"
export * from "./WeaponWidget.vue?vue&type=script&lang=js"
import style0 from "./WeaponWidget.vue?vue&type=style&index=0&id=23f87ed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f87ed2",
  null
  
)

export default component.exports